export const checkArrForMapping = (data: unknown): boolean => {
    if (!data) return false;
    return Array.isArray(data) && data?.length > 0;
}